import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Grid, Card, CardContent,
   Chip, Divider, CircularProgress, Stack, Tooltip, IconButton, Dialog, DialogTitle, DialogActions, Button } from '@mui/material';
import { WorkOutline, LocationOn, Event, ContactMail, Paid, Category, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import EditHiringPostDialog from './EditHiringPostDialog';
import { OrganizationHiretechupadate, OrganizationHiretechcopmany } from '../../../helper/base_url';

const CompanyHiringPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingPost, setEditingPost] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  //const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const fetchHiringPosts = async () => {
    try {
      const token = localStorage.getItem('company_token');
      const response = await axios.get(`${OrganizationHiretechcopmany}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      //console.log("API response:", response.data);
      setPosts(Array.isArray(response.data?.hirings) ? response.data.hirings : response.data?.data?.hirings || []);
    } catch (error) {
      //console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (post) => {
    setEditingPost(post);
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditingPost(null);
    setEditOpen(false);
  };

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem('company_token');
      await axios.delete(`${OrganizationHiretechupadate}`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { hiringId: deleteTarget._id },
      });
      fetchHiringPosts();
      setDeleteTarget(null);
    } catch (error) {
      console.error('Error deleting post:', error);
    }
  };

  useEffect(() => {
    fetchHiringPosts();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
        <CircularProgress size={40} />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4, mt: 6, height : 'calc(100vh - 90px)', overflowY: 'auto' }}>
      <Grid container spacing={4}>
        {Array.isArray(posts) && posts.map((post, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card sx={{ borderRadius: 4, boxShadow: 4, position: 'relative' }}>
              <Box sx={{ position: 'absolute', top : 8, right : 8, display: 'flex', gap: 1 }}>
                <IconButton onClick={() => handleEdit(post)}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => setDeleteTarget(post)}>
                  <DeleteIcon color="error" />
                </IconButton>
              </Box>
              <CardContent>
                <Stack spacing={1} mb={2}>
                  <Typography variant="h6">
                    <WorkOutline fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
                    {post?.opportunityOverview?.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <Category fontSize="inherit" sx={{ mr: 1 }} />
                    {post?.roleDetails?.domain}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} flexWrap="wrap" mb={2}>
                  <Chip icon={<LocationOn />} label={post?.opportunityOverview?.location} variant="outlined" />
                  <Chip label={`Status: ${post.status || 'Open'}`} color={post.status === 'Open' ? 'success' : 'default'} variant="filled" />
                  <Chip icon={<Paid />} label={post?.compensationAndDates?.stipendOrSalary} variant="outlined" />
                  <Chip label={`Experience: ${post?.opportunityOverview?.experience}`} variant="outlined" />
                </Stack>
                <Divider sx={{ my: 2 }} />
                <Stack spacing={1}>
                  <Typography variant="body2">
                    <Event sx={{ fontSize: 18, mr: 1 }} />
                    Deadline: {post?.compensationAndDates?.applicationDeadline?.slice(0, 10)}
                  </Typography>
                  <Typography variant="body2">
                    <ContactMail sx={{ fontSize: 18, mr: 1 }} />
                    {post?.contactInformation?.contactEmail}
                  </Typography>
                </Stack>
                <Typography mt={2} variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                  {post?.roleDetails?.roleOverview}
                </Typography>
                <Box mt={2} display="flex" flexWrap="wrap" gap={0.5}>
                  {post?.roleDetails?.skills?.map((skill, i) => (
                    <Tooltip title="Required Skill" arrow key={i}>
                      <Chip label={skill} size="small" variant="outlined" />
                    </Tooltip>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <EditHiringPostDialog
        open={editOpen}
        onClose={handleEditClose}
        post={editingPost}
        onUpdate={fetchHiringPosts}
      />

      <Dialog open={Boolean(deleteTarget)} onClose={() => setDeleteTarget(null)}>
        <DialogTitle>Are you sure you want to delete this post?</DialogTitle>
        <DialogActions>
          <Button onClick={() => setDeleteTarget(null)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CompanyHiringPosts;
